// src/pages/CategoriesPage.js
import React, { useState, useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import apiClient from '../api/apiClient';
import CategoryItem from '../components/Category/CategoryItem';
import LoadingSpinner from '../components/common/LoadingSpinner';

const CategoriesPage = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCategories = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiClient.get('/products/categories/all/', {
                headers: { 'Accept-Language': 'fa' }
            });
            let allCategories = response.data || [];

            // فیلتر کردن دسته‌بندی‌هایی که خودشان یا زیردسته‌هاشان محصول دارند
            const filteredCategories = allCategories.filter(category => {
                const hasSelfProducts = category.product_count > 0;
                const hasChildrenWithProducts = (category.children || []).some(child => child.product_count > 0);
                return hasSelfProducts || hasChildrenWithProducts;
            });

            setCategories(filteredCategories);
            setError(null);
        } catch (err) {
            console.error("Error fetching all categories:", err);
            setError("در بارگذاری دسته‌بندی‌ها خطایی رخ داد.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchCategories();
    }, [fetchCategories]);

    if (loading) {
        return (
            <div className="container mx-auto p-4 md:p-6 max-w-[460px] rtl">
                <LoadingSpinner text="در حال بارگذاری دسته‌بندی‌ها..." />
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mx-auto p-4 md:p-6 text-center text-red-600 rtl max-w-[460px]">
                <h1 className="text-2xl font-bold mb-4">خطا</h1>
                <p>{error}</p>
            </div>
        );
    }

    const defaultOgImage = 'https://s3.afra.kubit.cloud/mahsacanva1365-far-free/profile/og-image.jpg';
    const pageTitle = 'دسته‌بندی درس‌گفتارها و محصولات | فرزانه';
    const pageDescription = 'مرور دسته‌بندی‌های مختلف محصولات فرزانه شامل فلسفه، روانشناسی، هنر زندگی، دین و سایر موضوعات مرتبط با آثار مصطفی ملکیان و دیگر اندیشمندان.';

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:image" content={defaultOgImage} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={window.location.href} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                <meta name="twitter:image" content={defaultOgImage} />
            </Helmet>

            <div className="categories-page rtl container mx-auto p-4 md:p-6 pb-20 max-w-[460px]">
                <h1 className="text-3xl font-extrabold text-gray-800 mb-6 text-center">
                     دسته‌بندی درس‌گفتارها
                </h1>

                {categories.length === 0 ? (
                    <div className="text-center text-gray-500 py-10 border border-gray-200 p-4 rounded-lg">
                        <p className="font-medium">
                            متأسفانه هیچ دسته‌بندی با محتوا یافت نشد.
                        </p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 gap-6">
                        {categories.map(category => (
                            <CategoryItem
                                key={category.slug}
                                category={category}
                            />
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default CategoriesPage;